import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Bookmark, ArrowUpRight } from "lucide-react";

const PLACEHOLDER = "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=80";

const ListingCard = ({ listing }) => {
  const img = listing.cover_image_url || listing.logo_url || PLACEHOLDER;
  const slug = listing.slug || listing.id;
  const tags = [];
  if (listing.category?.name) tags.push(listing.category.name);
  if (listing.subcategory) tags.push(listing.subcategory);

  return (
    <div className="group relative bg-white rounded-3xl overflow-hidden card-shadow flex flex-col border border-[#F1F5F9]">
      <Link to={`/attivita/${slug}`} className="relative block aspect-[16/10] overflow-hidden">
        <img
          src={img} alt={listing.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/25 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <div className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-white/95 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all">
          <ArrowUpRight className="w-4 h-4 text-[#12964A]" />
        </div>
      </Link>

      <div className="p-6 flex flex-col flex-1">
        {tags.length > 0 && (
          <div className="flex items-center gap-1.5 text-xs text-slate-500 mb-3">
            {tags.map((t) => (
              <span key={t} className="px-2.5 py-1 rounded-full bg-[#F0FAF3] text-[#0E7C3D]">{t}</span>
            ))}
          </div>
        )}
        <Link to={`/attivita/${slug}`}>
          <h3 className="font-display font-bold text-2xl text-[#1F2937] mb-1 group-hover:text-[#12964A] transition-colors">
            {listing.name}
          </h3>
        </Link>
        {listing.short_description && (
          <p className="text-sm text-slate-500 mb-4 line-clamp-2">{listing.short_description}</p>
        )}

        <div className="mt-auto space-y-2 text-sm text-slate-600">
          {listing.address && (
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-slate-400" />
              <span className="line-clamp-1">{listing.address}</span>
            </div>
          )}
          {listing.phone && (
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-slate-400" /> {listing.phone}
            </div>
          )}
        </div>

        <div className="flex items-center justify-between mt-5 pt-5 border-t border-slate-100">
          <span className="text-xs uppercase tracking-[0.18em] text-slate-400">Sanluri</span>
          <Link to={`/attivita/${slug}`} className="text-sm text-[#12964A] link-underline font-medium">
            Vedi dettagli
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
